import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'

import Autocomplete from 'vuejs-auto-complete'
import VueNumericInput from 'vue-numeric-input'

export default {
    name: 'CustomerCreate',
    created,
    data,
    methods,
    components: {
        Autocomplete,
        VueNumericInput
    }
}
